import useCrowdHandler from './components/crowd-handler';
import AppRoutes from './routes/app-routes';

const App = () => {
  useCrowdHandler();
  return <AppRoutes />;
};

export default App;
